import React, { useState } from 'react';
import classNames from 'classnames';
import ImageContainer from '@/components/ImageContainer/ImageContainer';
import Image from 'next/image';
import GalleryModal from './GalleryModal';
import { composeImageUrl } from '@/utils/imageAsset';
import { ContentGalleryType } from '@/utils/common.types';

interface Props {
  sectionContent: ContentGalleryType[];
  isLeft: boolean;
  includeCardTitles: boolean;
}

const GallerySection = ({
  sectionContent,
  isLeft,
  includeCardTitles,
}: Props) => {
  const [modalContent, setModalContent] = useState<ContentGalleryType | null>(
    null
  );

  const toggleModal = () => {
    setModalContent(null);
  };

  return (
    <>
      <div
        className={classNames(
          'mb-4 grid grid-rows-1 md:gap-x-4 md:gap-y-[11px]',
          {
            ['md:grid-cols-4 md:grid-rows-2']: sectionContent.length === 5,
            ['md:grid-cols-2 md:grid-rows-2']: sectionContent.length === 4,
            ['md:grid-cols-3 md:grid-rows-1']: sectionContent.length <= 3,
          }
        )}
      >
        {sectionContent.map((item, key) => (
          <div
            className={classNames('relative cursor-pointer', {
              ['md:col-start-1 md:col-end-3 md:row-start-1 md:row-end-3']:
                sectionContent.length === 5 && key % 5 === 0 && isLeft,
              ['md:col-start-3 md:col-end-3 md:row-start-1 md:row-end-3']:
                sectionContent.length === 5 && key % 5 === 0 && !isLeft,
            })}
            key={key}
          >
            <div
              onClick={(e) => {
                e.preventDefault();
                setModalContent(item);
              }}
            >
              <ImageContainer
                src={composeImageUrl({
                  image: item?.image?.desktop,
                  h: 400,
                  w: 400,
                  fm: 'webp',
                })}
                alt={item?.title || `Gallery Item ${key}`}
              />
              {item?.__typename === 'VideoCard' && (
                <div className="absolute left-[40%] top-[42%] flex h-[50px] w-[50px] items-center justify-center rounded-full bg-clayton-blue">
                  <div className="items center flex h-10 w-10 rounded-full bg-grey-3 pl-2">
                    <Image
                      src="/public-assets/play-button-triangle.svg"
                      alt="Play Button"
                      height={30}
                      width={30}
                    />
                  </div>
                </div>
              )}
              {includeCardTitles && (
                <div className="mb-[15px] mt-2 font-acumin text-[1rem] font-semibold">
                  {item?.title}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {modalContent !== null && (
        <GalleryModal galleryItem={modalContent} onClose={toggleModal} />
      )}
    </>
  );
};

export default GallerySection;
